// @flow
import { FLAGS_TOGGLE } from 'actions/flags';
import { decodeAuthToken } from 'utils/auth';

export type State = {|
  +authenticated: boolean,
  +hasSubscription: boolean,
|};

const token = decodeAuthToken();

const INITIAL_STATE: State = {
  authenticated: token ? token.exp > +new Date() / 1000 : false,
  hasSubscription: false,
};

export default function reduce(
  state: State = INITIAL_STATE,
  { type, ...payload }
) {
  switch (type) {
    case FLAGS_TOGGLE: {
      const { flag, state } = payload;
      return {
        ...state,
        [flag]: state,
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/flags.js